import type { Chord } from '../chord/index.js'

const PREFIX_LENGTH = 3

/**
 * Given the section's chord progression, return the prefix the Cadence Lab
 * should play ahead of each cadence ending. v1 rule: the section's chord list
 * trimmed to its last 3 chords (or fewer if the section has fewer than 3
 * chords).
 *
 * Why 3:
 *   - 2 chords is too thin to establish key context.
 *   - 4+ chords adds length without teaching more.
 *   - 3 is enough to land "I-IV-V-?" or "vi-IV-V-?" — the ear has a phrase to
 *     anchor on.
 *
 * The trigger button enforces a minimum of 3 chords (`disabled` otherwise), so
 * the fewer-than-3 fall-through is defensive — belt-and-suspenders for hosts
 * that mount the drawer directly.
 */
export const getCadencePrefix = (sectionChords: Chord[]): Chord[] => {
  if (sectionChords.length <= PREFIX_LENGTH) {
    return sectionChords
  }
  return sectionChords.slice(-PREFIX_LENGTH)
}
